const { dateBucket } = require('./dateGroups');

function insideChatPushMessageId(query) {
  const raw = query && query.msg;
  const value = Array.isArray(raw) ? raw[0] : raw;
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return null;
  return n;
}

function insideChatPushScrollPlan({
  query,
  messages,
  resolvedMessageId,
  usesDateGroups,
  now,
} = {}) {
  const id = insideChatPushMessageId(query);
  if (!id) return null;
  const list = Array.isArray(messages) ? messages : [];
  const row = list.find((message) => Number(message && message.id) === id);
  if (!row) return { id, found: false, expandResolved: false, expandGroup: null };
  const resolved = Number(resolvedMessageId);
  const expandResolved =
    Number.isFinite(resolved) && resolved > 0 && id <= resolved;
  const when = row.datetime || row.createdAt || row.createdOn;
  return {
    id,
    found: true,
    expandResolved,
    expandGroup: usesDateGroups ? dateBucket(when, now || new Date()) : null,
  };
}

function scrollPanelChildToCenter(panel, child) {
  if (!panel || !child || typeof panel.getBoundingClientRect !== 'function') {
    return;
  }
  if (typeof child.getBoundingClientRect !== 'function') return;
  const panelBox = panel.getBoundingClientRect();
  const childBox = child.getBoundingClientRect();
  const delta =
    childBox.top - panelBox.top - (panel.clientHeight - childBox.height) / 2;
  panel.scrollTop += delta;
}

module.exports = {
  insideChatPushMessageId,
  insideChatPushScrollPlan,
  scrollPanelChildToCenter,
};
